/** Persist server agent session IDs per tenant and agent type. */

export type AgentSessionKey =
  | "architect"
  | "architect-api-description"
  | "cms"
  | "developer-guide"
  | "production-support"
  | "integration-support"
  | "product-manager"
  | "concierge"
  | "devops"
  | "architect-intake";

const STORAGE_PREFIX = "sami:agent-session";

export interface StoredAgentSession {
  sessionId: string;
  updatedAt: number;
}

function storageKey(agentKey: AgentSessionKey, tenantId: string): string {
  return `${STORAGE_PREFIX}:${agentKey}:${tenantId}`;
}

export function getStoredAgentSession(
  agentKey: AgentSessionKey,
  tenantId: string | null | undefined,
): StoredAgentSession | null {
  if (!tenantId) return null;
  try {
    const raw = localStorage.getItem(storageKey(agentKey, tenantId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAgentSession;
    if (!parsed?.sessionId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setStoredAgentSession(
  agentKey: AgentSessionKey,
  tenantId: string | null | undefined,
  sessionId: string,
): void {
  if (!tenantId) return;
  const entry: StoredAgentSession = {
    sessionId,
    updatedAt: Date.now(),
  };
  localStorage.setItem(storageKey(agentKey, tenantId), JSON.stringify(entry));
}

export function clearStoredAgentSession(
  agentKey: AgentSessionKey,
  tenantId: string | null | undefined,
): void {
  if (!tenantId) return;
  localStorage.removeItem(storageKey(agentKey, tenantId));
}

export function clearAllAgentSessionsForTenant(
  tenantId: string | null | undefined,
): void {
  if (!tenantId) return;
  const keys: AgentSessionKey[] = [
    "architect",
    "architect-api-description",
    "cms",
    "developer-guide",
    "production-support",
    "integration-support",
    "product-manager",
    "concierge",
    "devops",
    "architect-intake",
  ];
  for (const agentKey of keys) {
    clearStoredAgentSession(agentKey, tenantId);
  }
}
